import { useContext } from "react";
import CurrentUserCrewContext from "../context/CurrentUserCrewContext";

const useContextUserCrew = () => useContext(CurrentUserCrewContext);

export default useContextUserCrew;
